import { useEffect, useRef } from 'react';
import useAuth from '../../utilities/hooks/useAuth';
import { StorageItems } from '../../shared/constants/app';
import {
  addItemToLocalstorage,
  removeItemFromLocalstorage,
} from '../../utilities/common/storage';
import { clearAuthTokenData, setTokenData } from '../../utilities/common/token';
import { userStore } from '../../utilities/common/userStore';
import { exchangeLegacyToken, self } from '../../shared/service/auth';

export default function Admin() {
  const { user } = useAuth();
  const urlParams = new URLSearchParams(window.location.search);
  const bootstrapStarted = useRef(false);

  useEffect(() => {
    if (bootstrapStarted.current) return;
    bootstrapStarted.current = true;

    const org_id = urlParams.get('organisationId');
    const legacyToken = urlParams.get('token');

    const applyOrgScope = (isStaff?: boolean) => {
      if (org_id) {
        if (isStaff) localStorage.setItem('org_id', org_id);
      } else {
        localStorage.removeItem('org_id');
      }
    };

    if (legacyToken) {
      const bootstrap = async () => {
        try {
          clearAuthTokenData();
          userStore.clear();
          removeItemFromLocalstorage(StorageItems.ACCESS_TOKEN);

          const tokens = await exchangeLegacyToken(legacyToken);
          setTokenData(tokens);

          const response: any = await self();
          applyOrgScope(response?.data?.isStaff);

          addItemToLocalstorage(StorageItems.SESSION_HINT, '1');

          window.location.href = '/';
        } catch {
          clearAuthTokenData();
          userStore.clear();
          removeItemFromLocalstorage(StorageItems.SESSION_HINT);
          window.location.href = '/login';
        }
      };

      bootstrap();
      return;
    }

    if (!user) {
      window.location.href = '/login';
      return;
    }

    applyOrgScope(user.isStaff);

    setTimeout(() => {
      window.location.href = '/';
    }, 2000);
  }, []);

  return (
    <div
      className={`hrdb-body-container bg-taupe-50 mt-[57px] flex flex-1 flex-col overflow-y-auto px-4 py-6 md:mt-[72px] md:p-6 lg:ml-60 lg:overflow-y-visible`}
    >
      Loading insights for your organisation
    </div>
  );
}
